module.exports = __webpack_public_path__ + "img/2.8012b9db.png";